class CustomSubscriptionWidget extends HTMLElement {
    connectedCallback() {
      this.select = this.querySelector('[js-select-plans]');
      this.priceDisplay = this.querySelector('.dr-subscription-normal-price');
      this.sellingPlanInput = document.querySelector('[name="selling_plan"]');
      this.priceElement = document.querySelector('.Buy_buttons_main_new .product_price_new');
      this.subscriptionWrap = this.querySelector('.dr-subscription-price-wrap');
  
      this.initEventListeners();
      this.updateInitialPrice();
    }
  
    initEventListeners() {
      // Handle one-time purchase selection
        this.addEventListener('change', (e) => {
            console.log(e.target);
        if (e.target.matches('input[name="drpurchaseOption"][value="onetime"]') || e.target.matches('label[js-dr-onetime-input]')) {
            this.handleOneTimeSelection();
        }
        if (e.target.matches('input[name="drpurchaseOption"][value="subscription"]')) {
            this.handleSubscriptionRadioSelected();
        }
        });
      // Handle subscription plan selection
      if (this.select && this.priceDisplay) {
        this.select.addEventListener('change', this.handlePlanChange.bind(this));
      }
    }
  
    handleOneTimeSelection() {
      const subscriptionPrice = document.querySelector('.injected-subscription-price');
      if (this.sellingPlanInput) this.sellingPlanInput.value = '';
      if (subscriptionPrice) subscriptionPrice.style.display = 'none';
      if (this.priceElement) this.priceElement.style.display = 'inline-block';
    }
  
    handlePlanChange() {
      const selectedOption = this.select.options[this.select.selectedIndex];
      const oneTimeInput = this.querySelector('[js-dr-subscription-input]');
      const price = selectedOption.getAttribute('js-dr-price');
      const sellingPlanValue = selectedOption.value;
      const sellingPlanInput = document.querySelector('input[name="selling_plan"]');
      if (oneTimeInput){oneTimeInput.click();}
      if (price){this.priceDisplay.textContent = price;}
      if (sellingPlanValue && sellingPlanInput){
        sellingPlanInput.value = sellingPlanValue; 
        sellingPlanInput.dispatchEvent(new Event('change', { bubbles: true }));
    }
  
      this.injectSubscriptionPrice();
    }
    handleSubscriptionRadioSelected() {
        const selectedOption = this.select.options[this.select.selectedIndex];
        const price = selectedOption.getAttribute('js-dr-price');
        const sellingPlanValue = selectedOption.value;
        const sellingPlanInput = document.querySelector('input[name="selling_plan"]');
        console.log(sellingPlanValue);
        if (price) this.priceDisplay.textContent = price;
        if (sellingPlanValue && sellingPlanInput){
            sellingPlanInput.value = sellingPlanValue;
            sellingPlanInput.dispatchEvent(new Event('change', { bubbles: true }));
        }
      
        this.injectSubscriptionPrice();
    }
    injectSubscriptionPrice() {
      let injectedDiv = document.querySelector('.injected-subscription-price');
  
      if (this.priceElement && this.subscriptionWrap) {
        this.priceElement.style.display = 'none';
  
        if (!injectedDiv) {
          injectedDiv = document.createElement('div');
          injectedDiv.className = 'injected-subscription-price';
          injectedDiv.innerHTML = this.subscriptionWrap.innerHTML;
          this.priceElement.parentNode.insertBefore(injectedDiv, this.priceElement.nextSibling);
        } else {
          injectedDiv.style.display = 'inline-block';
          injectedDiv.innerHTML = this.subscriptionWrap.innerHTML;
        }
      }
    }
  
    updateInitialPrice() {
      const initialOption = this.select?.options[this.select.selectedIndex];
      const initialPrice = initialOption?.getAttribute('js-dr-price');
      if (initialPrice) this.priceDisplay.textContent = initialPrice;
    }
  }
  
customElements.define('custom-subscription-widget', CustomSubscriptionWidget);